export default {
  author: {
    add: {
      success: 'L\'@:(author) @:(flash.hasBeenAdded)'
    },
    delete: {
      success: 'L\'@:(author) @:(flash.hasBeenDeleted)'
    },
    update: {
      success: 'L\'@:(author) @:(flash.hasBeenUpdated)'
    }
  },
  book: {
    add: {
      success: 'Le @:book @:flash.hasBeenAdded'
    },
    addDraft: {
      success: 'Le @:book @:flash.hasBeenSaved en tant que brouillon'
    },
    author: {
      add: {
        success: 'L\'@:author @:flash.hasBeenAdded au @:book'
      },
      remove: {
        success: 'L\'@:author @:flash.hasBeenRemoved du @:book'
      },
      updatePosition: {
        success: 'La position de l\'@:author @:(flash.hasBeenUpdated)e'
      }
    },
    delete: {
      success: 'Le @:book @:flash.hasBeenDeleted'
    },
    hide: {
      success: 'Le @:book @:(flash.hasBeenHidden)'
    },
    show: {
      success: 'Le @:book @:(flash.hasBeenShown)'
    },
    update: {
      success: 'Le @:book @:flash.hasBeenUpdated'
    },
    updateDraft: {
      success: 'Le brouillon du @:book @:flash.hasBeenUpdated'
    }
  },
  bookContent: {
    add: {
      success: 'Le @:content @:(flash.hasBeenAdded)'
    },
    delete: {
      success: 'Le @:content @:(flash.hasBeenDeleted)'
    },
    disable: {
      success: 'Le @:content @:(flash.hasBeenDisabled)'
    },
    enable: {
      success: 'Le @:content @:(flash.hasBeenEnabled)'
    },
    update: {
      success: 'Le @:content @:(flash.hasBeenUpdated)'
    },
    updatePosition: {
      success: 'La position du @:content @:(flash.hasBeenUpdated)e'
    }
  },
  bookTag: {
    add: {
      success: 'Le @:tag @:(flash.hasBeenAdded)'
    },
    delete: {
      success: 'Le @:tag @:(flash.hasBeenDeleted)'
    },
    update: {
      success: 'Le @:tag @:(flash.hasBeenUpdated)'
    }
  },
  collection: {
    add: {
      success: 'La @:collection @:(flash.hasBeenAdded)e'
    },
    delete: {
      success: 'La @:collection @:(flash.hasBeenDeleted)e'
    },
    update: {
      success: 'La @:collection @:(flash.hasBeenUpdated)e'
    },
    updatePosition: {
      success: 'La position de la @:collection @:(flash.hasBeenUpdated)e'
    }
  },
  configuration: {
    update: {
      success: 'La @:configuration @:(flash.hasBeenUpdated)e'
    }
  },
  error: {
    500: 'Une erreur est survenue',
    403: 'Vous n\'êtes pas autorisé pour cela !'
  },
  image: {
    incomplete: 'L\'image doit être complétée avant de pouvoir en ajouter une autre',
    error: {
      minWidth: 'Une image de type "{type}" doit avoir une largeur d\'au moins {minWidth} pixels',
      maxFileSize: 'L\'image est trop lourde: {sizeMo} mo et ne doit pas dépasser les {maxMo} mo'
    }
  },
  menu: {
    add: {
      success: 'Le @:menu @:(flash.hasBeenAdded)'
    },
    delete: {
      success: 'Le @:menu @:(flash.hasBeenDeleted)'
    },
    update: {
      success: 'Le @:menu @:(flash.hasBeenUpdated)'
    },
    updatePosition: {
      success: 'La position du @:menu @:(flash.hasBeenUpdated)e'
    },
    disable: {
      success: 'Le @:menu @:(flash.hasBeenDisabled)'
    },
    enable: {
      success: 'Le @:menu @:(flash.hasBeenEnabled)'
    }
  },
  order: {
    update: {
      success: 'La @:order @:(flash.hasBeenUpdated)e'
    },
    delete: {
      success: 'La @:order @:(flash.hasBeenDeleted)e'
    }
  },
  page: {
    add: {
      success: 'La @:page @:(flash.hasBeenAdded)e'
    },
    addDraft: {
      success: 'La @:page @:(flash.hasBeenSaved)e en tant que brouillon'
    },
    delete: {
      success: 'La @:page @:(flash.hasBeenDeleted)e'
    },
    hide: {
      success: 'La @:page @:(flash.hasBeenHidden)e'
    },
    show: {
      success: 'La @:page @:(flash.hasBeenShown)e'
    },
    update: {
      success: 'La @:page @:(flash.hasBeenUpdated)e'
    },
    updateDraft: {
      success: 'Le brouillon de la @:page @:(flash.hasBeenUpdated)'
    }
  },
  pageContent: {
    add: {
      success: 'Le contenu @:(flash.hasBeenAdded)'
    },
    delete: {
      success: 'Le contenu @:(flash.hasBeenDeleted)'
    },
    disable: {
      success: 'Le contenu @:(flash.hasBeenDisabled)'
    },
    enable: {
      success: 'Le contenu @:(flash.hasBeenEnabled)'
    },
    update: {
      success: 'Le contenu @:(flash.hasBeenUpdated)'
    }
  },
  post: {
    add: {
      success: 'L\'@:post @:(flash.hasBeenAdded)e'
    },
    delete: {
      success: 'L\'@:post @:(flash.hasBeenDeleted)e'
    },
    update: {
      success: 'L\'@:post @:(flash.hasBeenUpdated)e'
    }
  },
  postType: {
    add: {
      success: 'Le type d\'actualité @:(flash.hasBeenAdded)'
    },
    delete: {
      success: 'Le type d\'actualité @:(flash.hasBeenDeleted)'
    },
    update: {
      success: 'Le type d\'actualité @:(flash.hasBeenUpdated)'
    }
  },
  profile: {
    changePassword: {
      success: 'Le mot de passe @:flash.hasBeenUpdated'
    },
    update: {
      success: 'Votre compte @:flash.hasBeenUpdated'
    }
  },
  resource: {
    incomplete: 'La resource doit être complétée avant de pouvoir en ajouter une autre',
    error: {
      maxFileSize: 'La resource est trop lourde: {sizeMo} mo et ne doit pas dépasser les {maxMo} mo'
    }
  },
  user: {
    add: {
      success: 'l\'@:user @:flash.hasBeenAdded'
    },
    delete: {
      success: 'l\'@:user @:flash.hasBeenDeleted'
    },
    update: {
      success: 'l\'@:user @:flash.hasBeenUpdated'
    }
  },
  validationError: 'Le formulaire n\'est pas valide',
  hasBeenAdded: 'a bien été ajouté',
  hasBeenDeleted: 'a bien été supprimé',
  hasBeenDisabled: 'a bien été désactivé',
  hasBeenEnabled: 'a bien été activé',
  hasBeenHidden: 'a bien été caché',
  hasBeenRemoved: 'a bien été détaché',
  hasBeenSaved: 'a bien été sauvegardé',
  hasBeenShown: 'a bien été affiché',
  hasBeenUpdated: 'a bien été modifié'
}
